import * as Types from 'src/actions/filled-test/create/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { RootState } from 'src/reducers/RootReducer';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import FilledAptitudeTest from 'src/entities/FilledAptitudeTest';
import { FilledAptitudeTestResponse } from 'src/services/api-client/resource/FilledAptitudeTestResource';
import ValidatorService from 'src/services/validation/Validation.service';

export interface CreateFilledAptitudeTestAttempt extends Action {
  type: Types.CREATE_FILLED_APTITUDE_TEST_ATTEMPT;
}

export interface CreateFilledAptitudeTestSuccess extends Action {
  type: Types.CREATE_FILLED_APTITUDE_TEST_SUCCESS;
  payload: FilledAptitudeTestResponse;
}

export interface CreateFilledAptitudeTestFailure extends Action {
  type: Types.CREATE_FILLED_APTITUDE_TEST_FAILURE;
  payload: {};
}

export type CreateFilledAptitudeTestAction =
  CreateFilledAptitudeTestAttempt | CreateFilledAptitudeTestSuccess | CreateFilledAptitudeTestFailure;

export interface CreateFilledAptitudeTestThunk extends
  ThunkAction<Promise<CreateFilledAptitudeTestAction>, RootState, null> {
}

export const createFilledAptitudeTestAttempt: ActionCreator<CreateFilledAptitudeTestAttempt> = () => (
  {type: Types.CREATE_FILLED_APTITUDE_TEST_ATTEMPT}
);

export const createFilledAptitudeTestSuccess: ActionCreator<CreateFilledAptitudeTestSuccess> =
  (successPayload: FilledAptitudeTestResponse) => (
  {
    type: Types.CREATE_FILLED_APTITUDE_TEST_SUCCESS,
    payload: successPayload
  }
);

export const createFilledAptitudeTestFailure: ActionCreator<CreateFilledAptitudeTestFailure> = (error: {}) => (
  {
    type: Types.CREATE_FILLED_APTITUDE_TEST_FAILURE,
    payload: error
  }
);

export const createFilledAptitudeTest: ActionCreator<CreateFilledAptitudeTestThunk> = (
  filledAptitudeTest: FilledAptitudeTest, personId: number, personType: string
): CreateFilledAptitudeTestThunk => {

  return (dispatch: Dispatch<RootState>): Promise<CreateFilledAptitudeTestAction> => {
    dispatch(createFilledAptitudeTestAttempt());

    return ApiClient.filledAptitudeTest.create(filledAptitudeTest, {personId: personId, personType: personType})
      .then((response: AxiosResponse<FilledAptitudeTestResponse>): CreateFilledAptitudeTestSuccess => {

        const successPayload: FilledAptitudeTestResponse = response.data;

        return dispatch(createFilledAptitudeTestSuccess(successPayload));
      }).catch((e: { response: { data: { error: {} } } }): CreateFilledAptitudeTestFailure => {
        const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);
        return dispatch(createFilledAptitudeTestFailure(errorMessages));
      });
  };
};



// WEBPACK FOOTER //
// ./src/actions/filled-test/create/CreateFilledAptitudeTest.actions.tsx